import { render, staticRenderFns } from "./SelectLanguageMenu.component.vue?vue&type=template&id=16c65437&scoped=true"
import script from "./SelectLanguageMenu.component.vue?vue&type=script&lang=js"
export * from "./SelectLanguageMenu.component.vue?vue&type=script&lang=js"
import style0 from "./SelectLanguageMenu.component.vue?vue&type=style&index=0&id=16c65437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c65437",
  null
  
)

export default component.exports